import { ExportCrosstabSheetMap, ExportFile } from '@tableau/api-internal-contract-js';
import { ExportCrosstabOptionsDialogPresModel } from '../../gen-src/preslayer/PresModels';

export class ExportConverter {
  public static convertCrosstabOptionsDialogToMap(
    exportCrosstabOptionsDialogPm: ExportCrosstabOptionsDialogPresModel,
  ): ExportCrosstabSheetMap {
    const exportCrosstabSheetMap: ExportCrosstabSheetMap = {};
    for (const thumbnailPickerItems of exportCrosstabOptionsDialogPm.thumbnailSheetPickerItems) {
      exportCrosstabSheetMap[thumbnailPickerItems.sheetName] = thumbnailPickerItems.sheetdocId;
    }
    return exportCrosstabSheetMap;
  }
}

export function makeEmptyExportFile(): ExportFile {
  return { resultKey: '', hasUserSpecificContent: false };
}
